import { NgModule } from '@angular/core';
import { DndModule } from 'ng2-dnd';

import { GridExportService } from '../services/grid-export.service';
import { GridExportServiceMock } from '../fixtures/grid-export.service.mock';
import { PershingGrid2Module } from '../pershing-grid.module';

const PERSHING_SERVICES = [
    { provide: GridExportService, useClass: GridExportServiceMock }
];


@NgModule({
    imports: [
        PershingGrid2Module,
        DndModule.forRoot()
    ],
    providers: [
        ...PERSHING_SERVICES
    ],
    exports: [
        PershingGrid2Module
    ]
})
export class PershingGridTestingModule {}
